// i18n ignore
import { message } from 'ant-design-vue';
import Vue from 'vue';
function stringifyError(error) {
    if (error instanceof Error) {
        return [
            `name: ${error.name}`,
            `message: ${error.message}`,
            error.stack ? `stack:\n${error.stack}` : '',
            'cause' in error ? `cause: ${String(error.cause)}` : '',
        ].filter(Boolean).join('\n');
    }
    if (typeof error === 'object' && error !== null) {
        try {
            return JSON.stringify(error, null, 2);
        }
        catch {
            return String(error);
        }
    }
    return String(error);
}
/**
 * 弹出编辑器加载失败的错误弹窗，展示诊断信息供用户复制，并提供刷新重试按钮。
 * 返回一个永远不会 resolve 的 Promise —— 预期用户点击「刷新页面重试」来重新加载。
 */
export function showEditorLoadError(info) {
    const errorMessage = info.error instanceof Error ? info.error.message : String(info.error);
    const errorTime = new Date().toLocaleString();
    const summaryLines = [
        `页面地址: ${location.href}`,
        `CDN 地址: ${info.baseUrl}`,
        `编辑器版本: ${info.editorVersion}`,
        `错误信息: ${errorMessage}`,
        `错误时间: ${errorTime}`,
    ];
    const diagnosticLines = [
        '编辑器加载失败诊断信息',
        `页面地址: ${location.href}`,
        `CDN 地址: ${info.baseUrl}`,
        `编辑器版本: ${info.editorVersion}`,
        `错误时间: ${errorTime}`,
        `User Agent: ${navigator.userAgent}`,
        '',
        '错误详情:',
        stringifyError(info.error),
    ];
    const container = document.createElement('div');
    document.body.appendChild(container);
    // eslint-disable-next-line no-new
    new Vue({
        el: container,
        data() {
            return { visible: true };
        },
        methods: {
            async handleCopy() {
                try {
                    await navigator.clipboard.writeText(diagnosticLines.join('\n'));
                    message.success('已复制到剪贴板');
                }
                catch {
                    /* ignore */
                }
            },
            handleRetry() {
                location.reload();
            },
        },
        render() {
            return (<t-dialog visible={this.visible} header="编辑器加载失败" footer={false} closeBtn={false} closeOnEscKeydown={false} closeOnOverlayClick={false}>
          <p style="margin-bottom: 12px;">
            加载编辑器资源失败，请复制以下信息联系无极小助手：
          </p>

          <t-alert theme="error" icon={() => (<></>)}>
            {summaryLines.map((line, idx) => (<div key={idx} style="word-break: break-all;">{line}</div>))}
          </t-alert>

          <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 20px;">
            <t-button variant="outline" onClick={this.handleCopy}>
              复制信息
            </t-button>
            <t-button theme="primary" onClick={this.handleRetry}>
              刷新页面重试
            </t-button>
          </div>
        </t-dialog>);
        },
    });
    return new Promise(() => { });
}
